let counter = 0;

/**
 * Monotonic, per-session unique id for wiring ARIA relationships (`aria-controls`,
 * `aria-activedescendant`, listbox/option ids) inside the in-house form controls.
 * Not cryptographic — just stable and collision-free within a page.
 */
export function nextAdminuiId(prefix: string): string {
  return `${prefix}-${++counter}`;
}
